import { InfoCircle } from '@assets/svgs';
import { FormControl, RadioGroup } from '@mui/material';

import { InputLabel } from '@components/inputLabel';
import { Item, RadioButton, FormControlLabel, FormHelperText } from '@components/index';
import { CollapsedField } from '@components/quoteDetails/CollapsedField';
import { QFCTypeExecuted } from '@components/quoteDetails/QuoteFieldControl';

export interface RadioFieldProps extends QFCTypeExecuted {
  onBlur: () => void;
  isRequired: boolean;
  isRequiredBeforeBind?: boolean;
  getOptionValues: ({ isOverriding }: { isOverriding: boolean }) => Item[];
}

export const RadioField = ({
  setValue,
  attributeType,
  hoverText,
  errorMessage,
  isRequired,
  isRequiredBeforeBind,
  value,
  isCollapsed,
  isReadOnly,
  onBlur,
  getOptionValues,
  isOverriding,
}: RadioFieldProps) => {
  const options = getOptionValues({ isOverriding });
  if (isCollapsed) {
    const selectedOption = options.find((option) => option.value == value);
    return <CollapsedField label={attributeType.label} value={selectedOption?.label} />;
  }
  return (
    <FormControl required={isRequired} disabled={isReadOnly} error={!!errorMessage} onBlur={onBlur}>
      {/* TODO: id needs to be specific to quoteItem instance */}
      <InputLabel
        id={`${attributeType.id}-label`}
        error={!!errorMessage}
        required={isRequired}
        requiredBeforeBind={isRequiredBeforeBind}
        disabled={isReadOnly}
        shrink={false}
        tooltipTitle={hoverText}
        endIcon={hoverText ? <InfoCircle style={{ flexShrink: 0 }} /> : null}
        deprecated={attributeType.deprecated}
      >
        {attributeType.label}
      </InputLabel>
      <RadioGroup
        aria-labelledby={`${attributeType.id}-label`}
        row
        value={value ?? ''}
        onChange={(e) => setValue(e.target.value)}
        sx={{
          '& .MuiFormControlLabel-root': {
            marginLeft: 0,
            marginRight: 1,
          },
        }}
      >
        {options.map((opt: { value: string; label: string }) => (
          <FormControlLabel
            key={opt.value}
            value={opt.value}
            control={<RadioButton disabled={isReadOnly} hasError={!!errorMessage} />}
            label={opt.label}
          />
        ))}
      </RadioGroup>
      <FormHelperText>{errorMessage ?? ' '}</FormHelperText>
    </FormControl>
  );
};
